import React, { useState, useEffect } from 'react';
import { Alert, Card, Button, Form, Modal, ListGroup, Tabs, Tab,OverlayTrigger, Popover } from 'react-bootstrap'
import Select from 'react-select';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import Moment from 'moment';
import { addDays, addYears, subYears } from 'date-fns'
import SHA256 from "crypto-js/sha256";
import CurrencyInput from 'react-currency-input-field';
import DatePicker from 'react-datepicker';
import { isNull } from 'lodash';
import ReactGA from "react-ga";
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';

export default function BikeIns(props) {
    let query = new URLSearchParams(useLocation().search);
    const [key, setKey] = useState(query.get("paymentID") === null ? 'Sum' : query.get("keyTab"));
    const [planInfo, setPlanInfo] = useState([]);
    const [addonsInfo, setAddonsInfo] = useState([]);
    const [ownerInfo, setOwnerInfo] = useState([]);
    const [sumInfo, setSumInfo] = useState([]);

    
    useEffect(() => {
        // Use the referral prop as needed in the component

        console.log("CI ="+props.referral);
        
    }, [props.referral]);

    return (
        <section id="body">
            <div className="container">
                <div className="row shadow title position-relative">
                    <div className="col-12">
                        <h2 className="text-center m-5 text-white font-weight-bold">Critical Illness Insurance</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10 px-0 shadow bg-white rounded">
                        <Tabs activeKey={key} variant="tabs"  onSelect={(k) => setKey(k)}>
                            <Tab eventKey="Sum" title="Get Quote" disabled={true}>
                                <Sum setKey={setKey} setSumInfo={setSumInfo} />
                            </Tab>
                            <Tab eventKey="plan" title="Select Plan" disabled={true}>
                                <Plan setKey={setKey} setPlanInfo={setPlanInfo} sumInfo={sumInfo} />
                            </Tab>
                            <Tab eventKey="addons" title="Add-ons" disabled={true}>
                                <Addons setKey={setKey} setAddonsInfo={setAddonsInfo} sumInfo={sumInfo} planInfo={planInfo} />
                            </Tab>
                            <Tab eventKey="question" title="Questionnaire" disabled={true}>
                                <Question setKey={setKey} addonsInfo={addonsInfo} sumInfo={sumInfo} planInfo={planInfo} />
                            </Tab>
                            <Tab eventKey="owner" title="My Info" disabled={true}>
                                <Owner setKey={setKey} setOwnerInfo={setOwnerInfo} addonsInfo={addonsInfo} sumInfo={sumInfo} planInfo={planInfo} />
                            </Tab>
                            <Tab eventKey="summary" title="Summary" disabled={true}>
                                <Summary setKey={setKey} ownerInfo={ownerInfo} addonsInfo={addonsInfo} sumInfo={sumInfo} planInfo={planInfo} referral={props.referral}/>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="col-1"></div>
                </div>
            </div>
        </section>
    );
}

function Sum(props) {
    const [idNo, setIdNo] = useState("");
    const [emailAdd, setEmailAdd] = useState("");
    const [dob, setDOB] = useState("");
    const [dob1, setDOB1] = useState("");
    const [gender, setGender] = useState("");
    const [smoker, setSmoker] = useState("");    
    const [nationalityCheck, setNationalityCheck] = useState("No");
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const currentDate = new Date();
    // Calculate the date 15 days ago
    currentDate.setDate(currentDate.getDate() - 15);
    // Format the date as 'YYYY-MM-DD'
    const maxSelectableDate = currentDate.toISOString().split('T')[0];

function onClickNext(e) {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() !== false) {
        e.preventDefault();
        e.stopPropagation();

        const age = calculateAge(dob1);
        const heightInMeters = height / 100; // Convert height to meters
        const bmiValue = (weight / (heightInMeters * heightInMeters)).toFixed(2); // Calculate BMI

        if (age !== null) {
            if (age >= 18 && age <= 60) {
                if (height < 133 || height > 220 || isNaN(height)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops, Sorry!',
                        text: 'Your BMI is not within the normal range. We are unable to proceed with the application',
                    });
                    setHeight("");
                } else {
                    if (bmiValue >= 16 && bmiValue <= 29.99) {
                        props.setSumInfo({
                            dob: dob,
                            email: emailAdd,
                            gender: gender,
                            smoker: smoker,
                            height: height,
                            weight: weight,
                            bmi: bmiValue,
                            age: age
                        });
                        props.setKey("plan");
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops, Sorry!',
                            html: '<p>Your Body Mass Index (BMI) is not within the normal range</p><p>We are unable to proceed with your application</p>'
                        });
                        setHeight("");
                    }
                }
            } else if (age < 18) {
                props.setSumInfo({
                    dob: dob,
                    email: emailAdd,
                    gender: gender,
                    smoker: smoker,
                    height: height,
                    weight: weight,
                    bmi: bmiValue,
                    age: age
                });
                props.setKey("plan");
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops, Sorry!',
                    text: 'Eligible age for Critical Safe+ is between 15 days to 60 years old, age next birthday. ',
                });
                setDOB1("");
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops, Sorry!',
                text: 'Eligible age for Critical Safe+ is between 15 days to 60 years old, age next birthday. ',
            });
            setDOB1("");
        }
    }
}


    // function onGetBrithDateAndGender(e) {
    //     setIdNo(e.target.value);
    //     var ic = e.target.value;

    //     if (ic.match(/^(\d{2})(\d{2})(\d{2})-?\d{2}-?\d{4}$/)) {
    //         // setNationality("Malaysian");

    //         let gender = parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'Female' : 'Male';
    //         setGender(gender);

    //         let dob = [];
    //         let date = new Date();

    //         for (var i = 0; i < ic.length; i += 2) {
    //             dob.push(parseInt(ic.substr(i, 2)));
    //         }

    //         if (dob[0] <= date.getFullYear().toString().slice(-2)) {
    //             dob[0] += 2000;
    //         } else {
    //             dob[0] += 1900;
    //         }

    //         const formattedDOB = new Date(
    //             new Date(dob[0] + '/' + (dob[1] < 10 ? '0' + dob[1] : dob[1]) + '/' + (dob[2] < 10 ? '0' + dob[2] : dob[2])).setHours(0, 0, 0, 0)
    //         );
    //         const year = formattedDOB.getFullYear();
    //         const month = (formattedDOB.getMonth() + 1).toString().padStart(2, '0');
    //         const day = formattedDOB.getDate().toString().padStart(2, '0');
            
    //         const formattedDate = `${year}/${month}/${day}`;
    //         console.log(formattedDate); // Output: "2023/12/28"
    //         setDOB(formattedDate);

    //     } else {
    //         // setNationality('');
    //         setGender('');
    //         setDOB('');
    //     }
    // }
const calculateAge = (selectedDate) => {
    const today = new Date();
    const birthDate = new Date(selectedDate);

    // Calculate next birthday
    const nextBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    if (nextBirthday < today) {
        nextBirthday.setFullYear(today.getFullYear() + 1);
    }

    // Calculate age without considering month and day
    let age = nextBirthday.getFullYear() - birthDate.getFullYear();

    // Calculate the age in days
    const ageInDays = Math.floor((nextBirthday - birthDate) / (24 * 60 * 60 * 1000));

    // Check if the age is between 15 days and 60 years
    if (ageInDays < 15 || age > 60) {
        return null; // or any value or message you want to indicate invalid age
    }

    return age;
};


    const handleDateChange = (e) => {
        // Parse the input date string to the desired format (YYYY/MM/DD)
        const inputDate = e.target.value;
        setDOB1(inputDate);
        const formattedDate = formatDate(inputDate);
        setDOB(formattedDate);
    };

    const formatDate = (dateString) => {
        // Assuming the input date format is 'YYYY-MM-DD'
        const [year, month, day] = dateString.split('-');
        return `${year}/${month}/${day}`;
    };

    const handleEmailBlur = () => {
        // Regular expression for basic email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isValid = emailRegex.test(emailAdd);
    
        if (!isValid) {
          Swal.fire({
            icon: 'error',
            title: 'Invalid Email',
            text: 'Please enter a valid email address.',
          });
          setEmailAdd("");
        }
      };

    
    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className="form-group row">
                        <label className="col-md-4 col-form-label">Email Address <span className='text-danger'>*</span></label>
                        <div className="col-md-8">
                        <input
                            type="email"
                            className="form-control"
                            required
                            value={emailAdd}
                            onChange={(e) => setEmailAdd(e.target.value)}
                            onBlur={handleEmailBlur}
                        />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-4 col-form-label">Date of Birth <span className='text-danger'>*</span>
                        <OverlayTrigger
                        trigger={['hover', 'click']}
                        key={"o1"}
                        placement="right"
                        overlay={
                            <Popover id={`popover-positioned-right`}>
                                <Popover.Content>
                                Age must be between 15 days to 60 years old
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                    </OverlayTrigger>
                        </label>
                        <div className="col-md-8">
                            <input
                                type="date"
                                className="form-control"
                                required
                                max={maxSelectableDate} // Set the maximum selectable date to the current date
                                value={dob1}
                                onChange={handleDateChange}
                                onInvalid={(e) => e.target.setCustomValidity('Minimum entry age is 15 days')}
                            />
                        </div>
                    </div>
                    <div className='form-group row'>
                        <label className="col-md-4 col-form-label">Gender <span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            <div className="form-group row">
                                <div className="col-sm-6">
                                    <Button
                                        block
                                        type="button"
                                        variant={gender === "Male" ? "primary" : "outline-primary"}
                                        className="mb-3 mb-sm-0"
                                        onClick={() => setGender("Male")}
                                    >
                                        Male
                                    </Button>
                                </div>
                                <div className="col-sm-6">
                                    <Button
                                        type="button"
                                        variant={gender === "Female" ? "primary" : "outline-primary"}
                                        className="mb-3 mb-sm-0"
                                        block
                                        onClick={() => setGender("Female")}
                                    >
                                        Female
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='form-group row'>
                        <label className="col-md-4 col-form-label">Are you a Smoker? <span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            <div className="form-group row">
                                <div className="col-sm-6">
                                    <Button
                                        type="button"
                                        variant={smoker === "No" ? "primary" : "outline-primary"}
                                        className="mb-3 mb-sm-0"
                                        block
                                        onClick={() => setSmoker("No")}
                                    >
                                        No
                                    </Button>
                                </div>
                                <div className="col-sm-6">
                                    <Button
                                        block
                                        type="button"
                                        variant={smoker === "Yes" ? "primary" : "outline-primary"}
                                        className="mb-3 mb-sm-0"
                                        onClick={() => setSmoker("Yes")}
                                    >
                                        Yes
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-4 col-form-label">Height (in cm) <span className='text-danger'>*</span></label>
                        <div className="col-md-8">
                            <input type="number" className="form-control" required value={height} onChange={(e) => setHeight(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-4 col-form-label">Weight (in kg) <span className='text-danger'>*</span></label>
                        <div className="col-md-8">
                            <input type="number" className="form-control" required value={weight} onChange={(e) => setWeight(e.target.value)} />
                        </div>
                    </div>
                    <br></br>
                    <hr></hr>
                    <div className="form-group row">
                        <div className="col-sm-1">
                            <input
                                type="checkbox"
                                name="nationality"
                                value="Yes"
                                checked={nationalityCheck === 'Yes'}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setNationalityCheck('Yes');
                                    } else {
                                        setNationalityCheck('No'); 
                                    }
                                }}
                                style={{ transform: 'scale(1.5)', marginRight: '8px' }} 
                            />
                        </div>
                        <div className="col-sm-11">
                            <label className="">
                            I am/We are a Malaysian citizen, permanent resident (PR) of Malaysia, legal work permit holder or employment pass holder who is legally residing in Malaysia.                            </label>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-12 text-center">
                        By clicking <span className='text-primary font-weight-bold'>"Continue"</span> button, you have read and agreed to our <a href='https://www.howdengroup.com/my-en/terms-and-conditions' target='_blank' className='text-primary font-weight-bold'>Terms and Conditions</a>.
                        </label>
                    </div>

                    {/* <div className={ nationalityCheck === "No" ? 'form-group row' : 'd-none'}>
                        <span className="col-sm-12 col-form-label small" style={{ color:  "red" }}>
                            Thank you for your interest in Critical Safe+. We regret to inform you that we are unable to proceed with your application.
                        </span>
                    </div> */}
                    <div className="form-group row mt-5 align-items-center">
                        <div className="col-12 text-right">
                            <Button
                                type="submit"
                                disabled={nationalityCheck === "No" || smoker === "" || gender === ""}
                            >
                                Continue
                            </Button>
                            {/* Add your other Button component here if needed */}
                        </div>
                    </div>

                </Card.Body>
            </Card>
        </Form>
    );
}

function Plan(props) {
    const [sumInsured, setSumInsured] = useState(30000);
    const [loading, setLoading] = useState(false);
    const [planPremium, setPlanPremium] = useState({ plans: [] });
    const [selectPlan, setSelectPlan] = useState({ plans: [] });
    const [pickPlan, setPickPlan] = useState("");
    const [getQuote, setGetQuote] = useState("");
    const [getProduct, setGetProduct] = useState("");
    const [transactionData, setTransactionData] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.sumInfo.length !== 0) {
          const fetchData = async () => {
            setLoading(true);
      
            const loadingSwal = Swal.fire({
              title: 'Please Wait...',
              allowOutsideClick: false,
              willOpen: () => {
                Swal.showLoading();
              },
              showConfirmButton: false // Remove the "OK" button
            });
      
            const newData = {
              dob: props.sumInfo.dob,
              email: props.sumInfo.email,
              gender: props.sumInfo.gender,
              idNo: props.sumInfo.idNo,
              smoker: props.sumInfo.smoker,
              sumInsured: sumInsured,
            };
      
            try {
              const response = await axios.post('/api/basic', {
                quote: newData
              }, {
                headers: {
                  "content-type": "application/json",
                }
              });
      
              console.log(response);
      
              if (parseFloat(response.data.plans[0].sumInsured) === sumInsured) {
                setPlanPremium(response.data);
                setGetQuote(response.data.quoteId);
                setGetProduct(response.data.productCode);
                setLoading(false);
                Swal.close();
              }
            } catch (error) {
              console.log(error);
              // Handle errors accordingly
              Swal.close();
            }
          };
      
          fetchData();
        }
      }, [props.sumInfo, sumInsured]);
      
    const getPlan = (data) => {
        setTransactionData({
            plan: data,
            product: getProduct,
            quote: getQuote,
            sumInsured: sumInsured
        });

    };

    function onClickNext(e) {

        e.preventDefault();

        const form = e.currentTarget;
        if ((form.checkValidity() !== false)) {
		
            e.preventDefault();
            e.stopPropagation();

            props.setPlanInfo(transactionData);
            props.setKey("addons");
        }
    }

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className="form-group row">
                        <label className="col-sm-12 text-center">
                            Select your Sum Insured
                        </label>
                        <div className="col-md-12 btn-group btn-group-toggle" role="plan">
                            <label className={sumInsured === 30000 ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            <input type="radio" name="gender" value="30000" onClick={() => setSumInsured(30000)} checked={sumInsured === 30000} />30,000
                            </label>
                            <label className={sumInsured === 50000 ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            <input type="radio" name="gender" value="50000" onClick={() => setSumInsured(50000)} checked={sumInsured === 50000} />50,000
                            </label>
                            <label className={sumInsured === 100000 ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            <input type="radio" name="gender" value="100000" onClick={() => setSumInsured(100000)} checked={sumInsured === 100000} />100,000
                            </label>
                        </div>
                    </div>
                    {
                    planPremium.plans.length > 0 ?
                    <div className="row">
                    {planPremium.plans.map((plan, index) => (
                        (index === 0 || index === 2) && (
                        <div className='col-md-6 d-flex align-items-stretch' key={index}>
                        {index === 0 ? (
                            <div className='flex-fill'>
                                <div className='card h-100'>
                                    <div className='card-body'>
                                        <h4 className='text-center'>Critical Safe+ {plan.displayName}</h4>
                                        <p className='text-center'>
                                        <span className='text-center' style={{'fontSize': '10px'}}>NO ADD-ONS AVAILABLE</span><br></br>
                                            Annual Premium
                                            <br></br>
                                            <span className='font-weight-bold h3 text-primary'>RM {(parseFloat(plan.basePremium) + 10).toFixed(2)}</span> /per year <br></br>
					    <span className='font-weight-bold'>RM {((parseFloat(plan.basePremium) + 10) / 12).toFixed(2)}</span> /per month
                                        </p>
                                        <hr></hr>
                                        <p>
                                            Sum Insured : <span className='font-weight-bold text-primary'>RM {parseFloat(plan.sumInsured).toLocaleString()}</span>
                                            <br></br>
                                            Cover advanced stages of : 
                                            <ul className='font-weight-bold text-primary'>
                                                <li>Heart Attack</li>
                                                <li>Stroke</li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div className='card-footer' style={{backgroundColor: 'white', borderTop: '0'}}>
                                    <Button
                                        type="submit"
                                        //variant={pickPlan === "1" ? "primary" : "outline-primary"}
                                        variant="outline-primary"
                                        className="mb-3 mb-sm-0"
                                        block
                                        onClick={() => {getPlan(plan); setPickPlan("1")}}
                                    >
                                        I Choose This
                                    </Button>
                                    </div>
                                </div>
                            </div>
                        ) : index === 2 ? (
                            <div className='flex-fill'>
                                <div className='card h-100'>
                                    <div className='card-body'>
                                        <h4 className='text-center'>Critical Safe+ {plan.displayName}</h4>
                                        <p className='text-center'>
                                        <span className='text-center' style={{'fontSize': '10px'}}>OPTIONAL ADD-ONS AVAILABLE</span><br></br>
                                            Annual Premium
                                            <br></br>
                                            <span className='font-weight-bold h3 text-primary'>RM {(parseFloat(plan.basePremium) + 10).toFixed(2)}</span> /per year <br></br>
					    <span className='font-weight-bold'>RM {((parseFloat(plan.basePremium) + 10) / 12).toFixed(2)}</span> /per month
                                        </p>
                                        <hr></hr>
                                        <p>
                                            Sum Insured : <span className='font-weight-bold text-primary'>RM {parseFloat(plan.sumInsured).toLocaleString()}</span>
                                            <br></br>
                                            Cover advanced stages of : 
                                            <ul className='font-weight-bold text-primary'>
                                                <li>Heart Attack</li>
                                                <li>Stroke</li>
                                                <li>Cancer</li>
                                                <li>Coronary Artery Disease</li>
                                                <li>Kidney Failure</li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div className='card-footer' style={{backgroundColor: 'white', borderTop: '0'}}>
                                    <Button
                                        type="submit"
                                        //variant={pickPlan === "2" ? "primary" : "outline-primary"}
                                        variant="outline-primary"
                                        className="mb-3 mb-sm-0"
                                        block
                                        onClick={() => {getPlan(plan); setPickPlan("2")}}
                                    >
                                        I Choose This
                                    </Button>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        </div>)
                    ))}
                    </div>

                    :
                        <div className="row">
                            <div className="col-12 text-center">
                                No Available Plans Found.
                            </div>
                        </div>
                    }
                    <div className="form-group row mt-5 align-items-center">
                        <div className="col-12">
                            <Button type="button" variant="info" className="mr-3" onClick={() => { props.setKey('Sum') }}>Back</Button>
                            {/* <Button type="submit">Continue</Button> */}
                            {/*
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                            */}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Addons(props) {
    const [loading, setLoading] = useState(false);
    const [getQuote, setGetQuote] = useState([]);
    const [checkbox1, setCheckbox1] = useState(false);
    const [checkbox2, setCheckbox2] = useState(false);
    const [inputPromo, setInputPromo] = useState('');
    const [discountAmount, setDiscountAmount] = useState(0);
    const [checkpromo, setCheckpromo] = useState('');
    const [code, setCode] = useState('');


    const handleInputChange = (event) => {
        setInputPromo(event.target.value);
    };
    
    const handleButtonClick = () => {

        const loadingSwal = Swal.fire({
            title: 'Please Wait...',
            allowOutsideClick: false,
            willOpen: () => {
              Swal.showLoading();
            },
            showConfirmButton: false // Remove the "OK" button
          });
        // Perform Axios POST request
        axios.post('/api/promo', { code: inputPromo })
            .then(response => {
                
                if(response.data){
                    Swal.close();
                }
                if (response.data && response.data.id) {
                    const { discount_amount, code, discount_percentage } = response.data;
                
                    if (discount_amount !== null && discount_amount !== "") {
                        setDiscountAmount(discount_amount);
                        setCheckpromo("Fixed");
                        // const newTotalPayable = props.totalPayable - parseFloat(discount_amount);
                        // props.setTotalPayable(newTotalPayable);
                        console.log('Discount Amount:', discount_amount);
                    } else if (discount_percentage !== null && discount_percentage !== "") {
                        setDiscountAmount(discount_percentage);
                        setCheckpromo("Percentage");
                        // const discountValue = (props.totalPayable * parseFloat(discount_percentage)) / 100;
                        // const newTotalPayable = props.totalPayable - discountValue;
                        //props.setTotalPayable(newTotalPayable);
                        console.log('Discount Percentage:', discount_percentage);
                    }
    
                    setCode(code);
                    console.log('Code:', code);
                } else {
                    Swal.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Promo Code is invalid'
                    });
                    setInputPromo('');
                }
            })
            .catch(error => {
            console.error('POST Error:', error);
            // Handle the error as needed
            });
        };
        const isPromoApplied = discountAmount !== 0 && code;

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.planInfo.length !== 0) {
          const fetchData = async () => {
            setLoading(true);
      
            const loadingSwal = Swal.fire({
              title: 'Please Wait...',
              allowOutsideClick: false,
              willOpen: () => {
                Swal.showLoading();
              },
              showConfirmButton: false // Remove the "OK" button
            });
      
            const newData = {
              product: props.planInfo.product,
              plan: props.planInfo.plan.planCode,
              quoteId: props.planInfo.quote,
            };
      
            try {
              const response = await axios.post('/api/quote', {
                quote: newData
              }, {
                headers: {
                  "content-type": "application/json",
                }
              });
      
              console.log(response);
              setGetQuote(response.data.data);
              setLoading(false);
              Swal.close();
            } catch (error) {
              console.log(error);
              // Handle errors accordingly
              Swal.close();
            }
          };
      
          fetchData();
        }
    }, [props.sumInfo, props.planInfo]);

    const handleCheckbox1Change = (e) => {
        setCheckbox1(e.target.checked);
    };

    const handleCheckbox2Change = (e) => {
        setCheckbox2(e.target.checked);
    };

    // Calculate total based on checkbox selections
    const calculateTotal = () => {
        let total = 0;

        if(getQuote.selectedPlanCode !== "TPMPR2CI" ){
            if (checkbox1) {
                let val1 = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[1].quotedAmount : "0";
                total += parseFloat(val1);
            }
    
            if (checkbox2) {
                let val2 = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[2].quotedAmount : "0";
                total += parseFloat(val2);
            }
        }
        return total;
    };

    const recalculateTotal = () => {
        let total = 0;
        let basic = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[0].quotedAmount : "0";
        let service = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[13].quotedAmount : "0";
        let stamp = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[8].quotedAmount : "0";
        total = parseFloat(basic) + parseFloat(service) + parseFloat(stamp);

        if(getQuote.selectedPlanCode !== "TPMPR2CI" ){
            if (checkbox1) {
                let val1 = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[1].quotedAmount : "0";
                total += parseFloat(val1);
            }
    
            if (checkbox2) {
                let val2 = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[2].quotedAmount : "0";
                total += parseFloat(val2);
            }
        }
        return total;
    };

    const recalculateTotal1 = () => {
        let total = 0;
        let basic = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[0].quotedAmount : "0";
        let service = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[13].quotedAmount : "0";
        let stamp = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[8].quotedAmount : "0";
        if(checkpromo == "Fixed")
        {
            total = (parseFloat(basic) - parseFloat(discountAmount)) + parseFloat(service) + parseFloat(stamp);
            console.log("fixed");
        }else if(checkpromo == "Percentage"){
            const discountPercentage = parseFloat(discountAmount) / 100; // Convert percentage to decimal
            const discountValue = parseFloat(basic) * discountPercentage; // Calculate discount value
            total = (parseFloat(basic) - discountValue) + parseFloat(service) + parseFloat(stamp);
            console.log("masuk");
        }else{
            total = parseFloat(basic) + parseFloat(service) + parseFloat(stamp);
        }

        if(getQuote.selectedPlanCode !== "TPMPR2CI" ){
            if (checkbox1) {
                let val1 = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[1].quotedAmount : "0";
                total += parseFloat(val1);
            }
    
            if (checkbox2) {
                let val2 = getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[2].quotedAmount : "0";
                total += parseFloat(val2);
            }
        }
        console.log("total: ". total);
        return total;
    };



    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();

            props.setAddonsInfo({
                amount: recalculateTotal(),
                promo: code,
                promoAmount: discountAmount,
                discountAmount: recalculateTotal1(),
                addons: calculateTotal(),
                basic: getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[0].quotedAmount : "0.00",
                tax: getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[13].quotedAmount : "0.00",
                stamp: getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[8].quotedAmount : "0.00",
                plan: getQuote.selectedPlanCode,
                diabetic: checkbox2,
                early: checkbox1
            });

            props.setKey("question");
        }
    }

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                <div className='row'>
                        <div className='col-md-7'>
                            {
                                getQuote.selectedPlanCode === "TPMPR2CI" ?
                                <div className='card'>
                                <div className='card-body'>
                                        <p>No Add-Ons Available</p>
                                </div>
                            </div>
                                :
                                <div>
                                <div className='card'>
                                <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-7'>
                                            <h5 className='font-weight-bold text-primary'>Early Stage Cover</h5>
                                            </div>
                                            <div className='col-5 text-right'>
                                            <input
                                                type="checkbox"
                                                name="checkbox1"
                                                value="Yes"
                                                checked={checkbox1}
                                                onChange={handleCheckbox1Change}
                                                style={{ transform: 'scale(2.0)', marginRight: '8px' }} 
                                            />
                                            </div>
                                        </div>
                                        <p>Covers Early Stage of Top 5 Critical Illnesses</p>
                                        <div className='row'>
                                            <div className='col-lg-6'>
                                                <ul>
                                                    <li>Heart Attack</li>
                                                    <li>Stroke</li>
                                                    <li>Cancer</li>
                                                </ul>
                                            </div>
                                            <div className='col-lg-6'>
                                                <ul>
                                                    <li>Coronary Artery Disease</li>
                                                    <li>Kidney Failure</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <hr></hr>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <p> Sum Insured<br></br><span className='font-weight-bold h5 text-primary'>RM {parseFloat(props.planInfo.sumInsured * 0.5).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span></p>                                          
                                            </div>
                                            <div className='col-md-6'>
                                                <p className='text-right'>
                                                <span className='font-weight-bold h5 text-primary'>RM {getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[1].quotedAmount : ""}</span> / per year
                                                </p>
                                            </div>
                                        </div>
                                </div>
                            </div>
                            <div className='card mt-3'>
                                <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-7'>
                                            <h5 className='font-weight-bold text-primary'>Diabetic Care Disease</h5>
                                            </div>
                                            <div className='col-5 text-right'>
                                            <input
                                                type="checkbox"
                                                name="checkbox2"
                                                value="Yes"
                                                checked={checkbox2}
                                                onChange={handleCheckbox2Change}
                                                style={{ transform: 'scale(2.0)', marginRight: '8px' }} 
                                            />
                                            </div>
                                        </div>
                                        <p>This standalone benefit will not affect the Sum Insured of the other benefits. It covers:</p>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <ul>
                                                    <li>Surgery for Type 2 Diabetic Retinopathy</li>
                                                    <li>Severe Diabetic Nephropathy</li>
                                                    <li>Limb Amputation due to Type 2 Diabetic Complications</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <hr></hr>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                            <p> Sum Insured<br></br><span className='font-weight-bold h5 text-primary'>RM {parseFloat(props.planInfo.sumInsured * 0.25).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span></p>         
                                            </div>
                                            <div className='col-md-6'>
                                                <p className='text-right'>
                                                <span className='font-weight-bold h5 text-primary'>RM {getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[2].quotedAmount : ""}</span> / per year
                                                </p>
                                            </div>
                                        </div>
                                </div>
                            </div>
                                </div>
                            }
                        </div>
                        <div className='col-md-5'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='text-center align-self-center'>
                                        <img src={"../images/tuneprotect.png"} alt="tune" className="img-fluid" width={320} />
                                        
                                    </div>
                                    <h6 className='text-center'>Total Yearly Premium</h6>
                                        <p className='text-center'>
                                            <span className='font-weight-bold h3 text-primary'>RM {recalculateTotal1().toFixed(2)}</span>
                                        </p>
                                        <hr></hr>
                                        <div className="row align-items-center">
                                            <label className="col-7">Basic Premium</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[0].quotedAmount : "0.00"}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Add-Ons</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {calculateTotal().toFixed(2)}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Service Tax (8%)</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[13].quotedAmount : "0.00"}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Stamp Duty</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {getQuote.detailedQuotation && getQuote.detailedQuotation.length > 0 ? getQuote.detailedQuotation[8].quotedAmount : "0.00"}
                                            </label>
                                        </div>
                                        {isPromoApplied && (
                                            <div className="row align-items-center">
                                                <label className="col-7 text-danger">Promo <br></br>({ code })</label>
                                                <label className="col-5 text-right align-self-center text-danger">
                                                - {checkpromo === "Fixed" ? `RM ${discountAmount}` : `${discountAmount}%`}
                                                </label>
                                            </div>
                                        )}
                                        <div className="input-group mb-3">
                                            <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Insert promo code here."
                                            aria-label="Promo"
                                            aria-describedby="basic-addon2"
                                            style={{
                                                borderRadius: '4rem 0 0 4rem'
                                            }}
                                            value={inputPromo}
                                            onChange={handleInputChange}
                                            disabled={isPromoApplied}
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className={`btn ${isPromoApplied ? 'btn-success' : 'btn-outline-primary'}`}
                                                    type="button"
                                                    onClick={handleButtonClick}
                                                    disabled={isPromoApplied}
                                                >
                                                    {isPromoApplied ? 'Applied' : 'Check'}
                                                </button>
                                            </div>
                                        </div>
                                        <hr></hr>
                                        <div className="row align-items-center">
                                            <label className="col-7 font-weight-bold">Total Annual Payable</label>
                                            {code === "" ? 
                                            <label className="col-5 text-right h5 text-primary font-weight-bold align-self-center">
                                                RM {recalculateTotal1().toFixed(2)}
                                            </label>
                                            :
                                            <label className="col-5 text-right align-self-center">
                                                <span className='h5 text-primary font-weight-bold'>RM {recalculateTotal1().toFixed(2)}</span> <br></br>
                                                <span style={{ textDecoration: 'line-through' }}>RM {recalculateTotal().toFixed(2)}</span>
                                            </label>
                                            }
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group row mt-5 align-items-center">
                        <div className='col-6'>
                        <Button type="button" variant="info" className="mr-3" onClick={() => { props.setKey('plan') }}>Back</Button>
                        </div>
                        <div className="col-6 text-right">
                            <Button type="submit">Continue</Button>
                            {/*
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                            */}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Question(props) {
    const [check, setCheck] = useState("");

    useEffect(() => {
        console.log(props.sumInfo);
        console.log(props.planInfo);
        console.log(props.addonsInfo);
        window.scrollTo(0, 0);
    }, [props.sumInfo, props.planInfo, props.addonsInfo]);

    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();

            props.setKey("owner");
        }
    }

    const handleButtonClick = (answer) => {
        if (answer === "No") {
            // Show a SweetAlert message when "No" is clicked
            Swal.fire({
                icon: 'info',
                title: 'Not Eligible',
                text: 'You are not eligible for the product.',
            });
            setCheck(answer);
        } else {
            setCheck(answer);
        }
    };

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className='row'>
                        <div className='col-md-12'>
                            <p>This questionnaire is for the applicant who is applying for this product. Please ensure the questions below are all answered to the best of the applicant's knowledge.</p>
                            <ol>
                                <li>I'm a Malaysian citizen, permanent resident (PR) of Malaysia, legal work permit holder or employment pass holder who is legally residing in Malaysia.</li>
                                <li>My current occupation are <span className='font-weight-bold'>NONE</span> of the following: -
                                    <ul>
                                        <li>Equestrian jockeys, Racing drivers, Professional Athletes</li>
                                        <li>Military, Armed Forces/Armed Personnel, Bodyguards</li>
                                        <li>Ship Crew, Shipbuilding and Repair Workers, Agricultural, Forestry or Fishery Workers</li>
                                        <li>Seamen, Divers, Oil and Gas Rig Workers, Power Plants Workers, Firefighters</li>
                                        <li>Mining workers who work underground or use explosives/chemicals</li>
                                        <li>Construction workers for dams, bridges, tunnels or underground work</li>
                                        <li>Window cleaners and construction workers at heights exceeding 30 ft above ground</li>
                                        <li>Workers that handle boilers, pressure vessels, explosives or toxic materials</li>
                                        <li>Circus Performers, Stuntmen/Stuntwomen, Prison Officers, Wild Animal Handlers</li>
                                        <li>Workers handling explosives and other toxic materials</li>
                                        <li>Heavy machinery and truck drivers *</li>
                                    </ul>
                                </li>
                                <li>I currently do <span className='font-weight-bold'>NOT</span> suffer from nor have I been diagnosed with any of the following medical conditions: -
                                    <ul>
                                        <li>Cancer, leukaemia, tumours, lump, abnormal growths or cysts</li>
                                        <li>Stroke, heart attack, chest pains, high blood pressure, heart disease, any disorder of the blood vessels</li>
                                        <li>Anaemia or any blood disorder, thyroid disorder</li>
                                        <li>Any childhood or congenital conditions, bone or joint disorders including arthritis, sciatica and rheumatism</li>
                                        <li>Hepatitis, liver cirrhosis, tuberculosis, or any other disease of the respiratory system</li>
                                        <li>Disorder of the lungs, liver, kidneys, or digestive system</li>
                                        <li>Psychotic, mental or nervous disorders, alcoholism or drug abuse</li>
                                        <li>Any physical defects, deformities, or motor impairments or any physical condition that affect my mobility, physical capacity, stamina, or dexterity</li>
                                        <li>Any diseases of the eyes, ears, nose, throat, mouth, skin, back, or spine</li>
                                        <li>AIDS or AIDS related complications</li>
                                        <li>Diabetes, raised blood sugar, sugar in urine, any condition affecting my pancreases, thyroid or hormones *</li>
                                    </ul>
                                </li>
                                <li>I have <span className='font-weight-bold'>NOT</span> experienced any of the following in the past 2 years: -
                                    <ul>
                                        <li>Suffered from any pain or discomfort due to a bodily injury or accident, for which I have yet to consult a doctor</li>
                                        <li>Consulted a medical practitioner or specialist for any medical conditions that will require investigation or further treatment</li>
                                        <li>Undergone a health screening that required further diagnostic tests, showed results that were not within the normal ranges / values, or showed imaging that detected unusual or suspicious findings *</li>
                                    </ul>
                                </li>
                                <li>I have <span className='font-weight-bold'>NOT</span> had any of my applications for insurance coverage, including renewal or reinstatement, ever been declined, postponed, rated up or accepted on special terms by any insurance company. *</li>
                                <li>In the past 6 months, I have <span className='font-weight-bold'>NOT</span> experienced any unexplained weight loss of 5kg or more, blood in urine, persistent coughing, bleeding from bowels or in stools, diarrhoea or constipation for consecutively 30 days or more. *</li>
                            </ol>
                            <p>I hereby declare that all the above statements are true and I have not withheld any information regarding this application.</p>
                            <p>I understand that it is my duty to take reasonable care not to make a misrepresentation in answering the questions in this whole application and I hereby declare that I have fully and accurately answered all the questions presented.</p>
                            <p className="text-center" style={{fontSize: "13px"}}>Note : If your answer is "No" to any of the above questions, you are no longer eligible to apply for this product.</p>
                        </div>
                        <div className='col-sm-2'></div>
                        <div className="col-sm-8">
                            <div className="form-group row">
                            <div className="col-sm-6">
                                <Button
                                    block
                                    type="button"
                                    variant={check === "Yes" ? "primary" : "outline-primary"}
                                    className="mb-3 mb-sm-0"
                                    onClick={() => handleButtonClick("Yes")} // Handle "Yes" button click
                                >
                                    Yes
                                </Button>
                            </div>
                            <div className="col-sm-6">
                                <Button
                                    type="button"
                                    variant={check === "No" ? "primary" : "outline-primary"}
                                    className="mb-3 mb-sm-0"
                                    block
                                    onClick={() => handleButtonClick("No")} // Handle "No" button click
                                >
                                    No
                                </Button>
                            </div>
                            </div>
                        </div>
                        <div className='col-sm-2'></div>
                    </div>
                    <div className="form-group row mt-5 align-items-center">
                    <div className='col-6'>
                        <Button type="button" variant="info" className="mr-3" onClick={() => { props.setKey('addons') }}>Back</Button>
                        </div>
                        <div className="col-6 text-right">
                        <Button
                                type="submit"
                                disabled={check === "No" || check === ""}
                            >
                                Continue
                            </Button>
                            {/*
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                            */}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Owner(props) {
    const [ownerName, setOwnerName] = useState("");
    const [ownerContactNo, setOwnerContactNo] = useState("");
    const [ownerIC, setOwnerIC] = useState("");
    const [ownerEmailAdd, setOwnerEmailAdd] = useState("");
    const [ownerAddr1, setOwnerAddr1] = useState("");
    const [ownerAddr2, setOwnerAddr2] = useState("");
    const [ownerPostcode, setOwnerPostcode] = useState("");
    const [ownerstate, setOwnerState] = useState("");
    const [selectedValue, setSelectedValue] = useState('');
    const [IDType, setIDType] = useState("");
    const [IDTypeList] = useState([
        { value: "NRIC Number", label: "NRIC Number" },
        { value: "Passport", label: "Passport" }
    ]);
    const [nationalities, setNationalities] = useState([]);
    const [selectedNationality, setSelectedNationality] = useState(''); 
    // policyholder
    const [policyName, setPolicyName] = useState("");
    const [policyGender, setPolicyGender] = useState("");
    const [policyDOB, setPolicyDOB] = useState("");
    const [policyDOB1, setPolicyDOB1] = useState("");
    const [PolicyIDType, setPolicyIDType] = useState("");
    const [policyIC, setPolicyIC] = useState("");
    const [selectedPolicyNationality, setSelectedPolicyNationality] = useState(''); 
    const [RelationshipList] = useState([
        { value: "Parent", label: "Parent" },
        { value: "Legal Guardian", label: "Legal Guardian" }
    ]);
    const [RelationshipType, setRelationshipType] = useState("");
    const [GenderList] = useState([
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" }
    ]);

    useEffect(() => {
        if (IDType == "NRIC Number") {
            setSelectedNationality("MYS");
            setOwnerIC("");
        } else {
            setSelectedNationality("");
            setOwnerIC("");
        }
    }, [IDType]);

    useEffect(() => {
        if (PolicyIDType == "NRIC Number") {
            setSelectedPolicyNationality("MYS");
            setPolicyIC("");
        } else {
            setSelectedPolicyNationality("");
            setPolicyIC("");
        }
    }, [PolicyIDType]);

    useEffect(() => {
        // Fetch nationalities from Laravel API
        fetch('/api/nationalities')
            .then(response => response.json())
            .then(data => {
                // Format data to match react-select options structure
                const formattedData = data.map(nationality => ({
                    value: nationality.code,
                    label: nationality.country
                }));
                setNationalities(formattedData);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    const handleSelectChange = (selectedOption) => {
	
        setSelectedNationality(selectedOption.value); // Store only the value
    };

    const handleSelectChange1 = (selectedOption) => {
        setSelectedPolicyNationality(selectedOption.value); // Store only the value
    };

    const handleChange = (event) => {
      setSelectedValue(event.target.value);
    };

    const handleDateChange = (e) => {
        // Parse the input date string to the desired format (YYYY/MM/DD)
        const inputDate = e.target.value;
        console.log(inputDate);
    
        // Assuming you have a calculateAge function available
        const age = calculateAge(inputDate);
    
        if (age !== null && age < 18) {
            // Display Swal error for age below 18
            Swal.fire({
                icon: 'error',
                title: 'Invalid Age!',
                text: 'Age must be above 18 years old.',
            });
            setPolicyDOB1('');
            setPolicyDOB('');
            return;
        }
    
        setPolicyDOB1(inputDate);
        const formattedDate = formatDate(inputDate);
        setPolicyDOB(formattedDate);
    };
    
    const formatDate = (dateString) => {
        // Assuming the input date format is 'YYYY-MM-DD'
        const [year, month, day] = dateString.split('-');
        return `${year}/${month}/${day}`;
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        console.log("owner");
        console.log(props.sumInfo);
        console.log(props.planInfo);
        console.log(props.addonsInfo);
    }, [props.sumInfo, props.planInfo, props.addonsInfo]);

const onGetBrithDate = (e) => {
        const inputValue = e.target.value;

        setOwnerIC(e.target.value);
        const givenDOB = props.sumInfo.dob;
        const enteredNRIC = e.target.value.replace(/-/g, ''); // Remove hyphens from entered NRIC
        const nricDOB = enteredNRIC.substring(0, 6); // Extract the first six digits as NRIC date of birth
        const lastDigit = parseInt(enteredNRIC.charAt(11), 10); // Extract the last digit
        const gender = lastDigit % 2 === 0 ? 'Female' : 'Male';

        if (nricDOB.length === 6) {
            if (nricDOB !== givenDOB.substring(2).replace(/\//g, '')) {
                // If the NRIC date does not match the given date of birth
                Swal.fire({
                    icon: 'error',
                    title: 'NRIC Date Mismatch',
                    text: 'The NRIC date does not match the given date of birth.',
                });
                setOwnerIC("");
            } else {
                // Set the NRIC value if validation passes
                setOwnerIC(e.target.value);
            }
        }
        if (enteredNRIC.length === 12){
            if(gender != props.sumInfo.gender){
                // If the NRIC date does not match the given date of birth
                Swal.fire({
                    icon: 'error',
                    title: 'NRIC Gender Mismatch',
                    text: 'The NRIC gender does not match the given gender.',
                });
                setOwnerIC("");
            } else {
                // Set the NRIC value if validation passes
                setOwnerIC(e.target.value);
            }
        }
    };

    function onGetBrithDateAndGender(e) {
        setPolicyIC(e.target.value);
        var ic = e.target.value;
    
        if (ic.match(/^(\d{2})(\d{2})(\d{2})-?\d{2}-?\d{4}$/)) {   
            let gender = parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 === 0 ? 'Female' : 'Male';
            setPolicyGender(gender);
    
            let dob = [];
            let date = new Date();
    
            // Extracting YYMMDD from the first 6 digits of NRIC
            for (var i = 0; i < 6; i += 2) {
                dob.push(parseInt(ic.substr(i, 2)));
            }
    
            if (dob[0] <= date.getFullYear().toString().slice(-2)) {
                dob[0] += 2000;
            } else {
                dob[0] += 1900;
            }
    
            // Creating a Date object with the adjusted month (subtracting 1)
            const formattedDOB = new Date(dob[0], dob[1] - 1, dob[2]);
    
            // Check if the age is below 18
            const age = calculateAge(formattedDOB.toISOString().split('T')[0]);
            if (age < 18) {
                // Display Swal error for age below 18
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Age!',
                    text: 'The person is below 18 years old.',
                });
                setPolicyIC('');
                setPolicyGender('');
                setPolicyDOB1('');
                return;
            }
    
            // Format the date as 'YYYY-MM-DD' in the local time zone
            const offset = formattedDOB.getTimezoneOffset();
            formattedDOB.setMinutes(formattedDOB.getMinutes() - offset);
            const formattedDateString = formattedDOB.toISOString().split('T')[0];
            // Set policyDOB1 with the formatted date
            setPolicyDOB1(formattedDateString);
            const formattedDate = formatDate(formattedDateString);
            console.log(formattedDate);
            setPolicyDOB(formattedDate);
        } else {
            // setNationality('');
            setPolicyGender('');
            setPolicyDOB1('');
        }
    }
    
    
    const calculateAge = (selectedDate) => {
        const today = new Date();
        const birthDate = new Date(selectedDate);
    
        // Calculate next birthday
        const nextBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
        if (nextBirthday < today) {
            nextBirthday.setFullYear(today.getFullYear() + 1);
        }
    
        // Calculate age without considering month and day
        let age = nextBirthday.getFullYear() - birthDate.getFullYear();
       
        return age;
    };    
    
    
    

    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();

            if (!IDType) {
                Swal.fire({
                    icon: 'error',
                    title: 'Opps',
                    text: 'Please select an ID Type',
                });
                return false;
            }


	if (!selectedNationality) {
                Swal.fire({
                    icon: 'error',
                    title: 'Opps',
                    text: 'Please select a Nationality',
                });
                return false;
            }


            if(props.sumInfo.age < 18){
                if (!PolicyIDType) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Opps',
                        text: 'Please select an Policyholder ID Type',
                    });
                    return false;
                }


                if (!selectedPolicyNationality) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Opps',
                        text: 'Please select a Policyholder Nationality',
                    });
                    return false;
                }


                if (!policyGender) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Opps',
                        text: 'Please select a Policyholder Gender',
                    });
                    return false;
                }

                if (!RelationshipType) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Opps',
                        text: 'Please select a Policyholder Relationship',
                    });
                    return false;
                }
            }

            if (ownerPostcode.length !== 5) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Postcode!',
                    text: 'Please enter a valid 5-digit postcode.',
                });
                return; // Stop further execution
            }

            if (IDType === "NRIC Number"){
                console.log(ownerIC.length);
                if(ownerIC.length !== 14){
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid NRIC!',
                        text: 'Please enter a valid NRIC Number.',
                    });
                    return; // Stop further execution
                }
            }

            if (PolicyIDType === "NRIC Number"){
                console.log(policyIC.length);
                if(policyIC.length !== 14){
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid NRIC!',
                        text: 'Please enter a valid NRIC Number.',
                    });
                    return; // Stop further execution
                }
            }

            props.setOwnerInfo({
                product: props.planInfo.product,
                quote: props.planInfo.quote,
                plan: props.addonsInfo.plan,
                age: props.sumInfo.age,
                ownerName: ownerName,
                ownerIC: ownerIC,
                nationality: selectedNationality,
                ownerContactNo: ownerContactNo,
                ownerEmailAdd: props.sumInfo.email,
                ownerAddr1: ownerAddr1,
                ownerAddr2: ownerAddr2,
                ownerPostcode: ownerPostcode,
                ownerstate: selectedValue,
                dob: props.sumInfo.dob,
                gender: props.sumInfo.gender,
                diabetic: props.addonsInfo.diabetic,
                early: props.addonsInfo.early,
                height: props.sumInfo.height,
                weight: props.sumInfo.weight,
                bmi: props.sumInfo.bmi,
                smoker: props.sumInfo.smoker,
                sumInsured: props.planInfo.sumInsured,
                amount: parseFloat(props.addonsInfo.amount).toFixed(2),
                policyName: policyName,
                policyIC: policyIC,
                policyDOB: policyDOB,
                policyNationality: selectedPolicyNationality,
                policyGender: policyGender,
                relationship: RelationshipType
            });

            props.setKey("summary");
        }
    }

    const handlePostcodeChange = (e) => {
        const inputPostcode = e.target.value;
        const regex = /^[0-9]{0,5}$/; // Regex to allow only digits with a maximum length of 5
    
        if (regex.test(inputPostcode)) {
            setOwnerPostcode(inputPostcode);
        }
    };

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className='row'>
                        <div className='col-md-7'>
                            <div className="form-group row">
                                <h5 className="col-sm-12">Insured Personal's Details </h5>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Full Name <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={ownerName} onChange={(e) => setOwnerName(e.target.value)} />
                                </div>
                            </div>
                            {/* <div className="form-group row">
                                <label className="col-sm-5 col-form-label">NRIC Number <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required disabled value={props.sumInfo.idNo} />
                                </div>
                            </div> */}
                            <div className="form-group row">
                                <label className="col-md-5 col-form-label">ID Type <span className='text-danger'>*</span></label>
                                <div className="col-md-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        placeholder="Select ID Type"
                                        required
                                        value={IDTypeList.find(obj => obj.label === IDType)}
                                        options={IDTypeList}
                                        onChange={(e) => { setIDType(e.label); }}
                                    />
                                </div>
                            </div>
                            {IDType === 'NRIC Number' ? (
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label">
                                        NRIC Number <span className='text-danger'>*</span>
                                    </label>
                                    <div className="col-md-7">
                                        <InputMask
                                            mask="999999-99-9999"
                                            maskChar=""
                                            type="text"
                                            className="form-control"
                                            required
                                            value={ownerIC}
                                            onChange={onGetBrithDate}
                                        />
                                    </div>
                                </div>
                            ) : IDType === 'Passport' ? (
                                <div className="form-group row">
                                    <label className="col-sm-5 col-form-label">Passport Number <span className='text-danger'>*</span></label>
                                    <div className="col-sm-7">
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            value={ownerIC}
                                            onChange={(e) => setOwnerIC(e.target.value)}
                                        />
                                    </div>
                                </div>
                            ) : ""}
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Nationality <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: '2rem' })
                                        }}
                                        options={nationalities}
                                        onChange={handleSelectChange}
                                        value={nationalities.find(option => option.value === selectedNationality)}
                                        placeholder="Select Nationality"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Gender <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" disabled value={props.sumInfo.gender} />
                                </div>
                            </div>      
                            {props.sumInfo.age < 18 ?
                            <div>
                            <div className="form-group row">
                                <h5 className="col-sm-12">Policyholder Details 
                                <OverlayTrigger
                        trigger={['hover', 'click']}
                        key={"o1"}
                        placement="right"
                        overlay={
                            <Popover id={`popover-positioned-right`}>
                                <Popover.Content>
                                The policyholder (also known as the applicant of the insured) is the person who applies for insurance. The policyholder is responsible for handling related insurance matters, such as changing policy information and rendering the policy
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                    </OverlayTrigger>
				</h5>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Full Name <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={policyName} onChange={(e) => setPolicyName(e.target.value)} />
                                </div>
                            </div>
                            {/* <div className="form-group row">
                                <label className="col-sm-5 col-form-label">NRIC Number <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required disabled value={props.sumInfo.idNo} />
                                </div>
                            </div> */}
                            <div className="form-group row">
                                <label className="col-md-5 col-form-label">ID Type <span className='text-danger'>*</span></label>
                                <div className="col-md-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        placeholder="Select ID Type"
                                        required
                                        value={IDTypeList.find(obj => obj.label === PolicyIDType)}
                                        options={IDTypeList}
                                        onChange={(e) => { setPolicyIDType(e.label); }}
                                    />
                                </div>
                            </div>
                            {PolicyIDType === 'NRIC Number' ? (
                                <div className="form-group row">
                                    <label className="col-md-5 col-form-label">
                                        NRIC Number <span className='text-danger'>*</span>
                                    </label>
                                    <div className="col-md-7">
                                        <InputMask
                                            mask="999999-99-9999"
                                            maskChar=""
                                            type="text"
                                            className="form-control"
                                            required
                                            value={policyIC}
                                            onChange={onGetBrithDateAndGender}
                                        />
                                    </div>
                                </div>
                            ) : PolicyIDType === 'Passport' ? (
                                <div className="form-group row">
                                    <label className="col-sm-5 col-form-label">Passport Number <span className='text-danger'>*</span></label>
                                    <div className="col-sm-7">
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            value={policyIC}
                                            onChange={(e) => setPolicyIC(e.target.value)}
                                        />
                                    </div>
                                </div>
                            ) : ""}
                            <div className="form-group row">
                                <label className="col-md-5 col-form-label">Date of Birth <span className='text-danger'>*</span>
                                </label>
                                <div className="col-md-7">
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        value={policyDOB1}
                                        onChange={handleDateChange}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Nationality <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: '2rem' })
                                        }}
                                        options={nationalities}
                                        onChange={handleSelectChange1}
					value={nationalities.find(option => option.value === selectedPolicyNationality)}
                                        placeholder="Select Nationality"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Gender <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        placeholder="Select ID Type"
                                        required
                                        value={GenderList.find(obj => obj.label === policyGender)}
                                        options={GenderList}
                                        onChange={(e) => { setPolicyGender(e.label); }}
                                    />
                                </div>
                            </div> 
                            <div className="form-group row">
                                <label className="col-md-5 col-form-label">Relationship <span className='text-danger'>*</span></label>
                                <div className="col-md-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        placeholder="Select Relationship"
                                        required
                                        value={RelationshipList.find(obj => obj.label === RelationshipType)}
                                        options={RelationshipList}
                                        onChange={(e) => { setRelationshipType(e.label); }}
                                    />
                                </div>
                            </div>
                            </div>
                            :
                            ""
                            }
                            <div className="form-group row">
                                <h5 className="col-sm-12">Contact Information </h5>
                            </div>      
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Contact Number <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                <input
                                    type="text"
                                    className="form-control"
                                    required
                                    value={ownerContactNo}
                                    onChange={(e) => setOwnerContactNo(e.target.value)}
                                    pattern="\d{10,}" // Specifies minimum 10 digits using pattern attribute
                                    title="Please enter at least 10 digits"
                                    maxLength="11"
                                    placeholder="012xxxxxxxx"
                                />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Email Address <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="email" className="form-control" required disabled value={props.sumInfo.email} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Address Line 1 <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={ownerAddr1} onChange={(e) => setOwnerAddr1(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Address Line 2</label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" value={ownerAddr2} onChange={(e) => setOwnerAddr2(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-5 col-form-label">Postcode <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={ownerPostcode} onChange={handlePostcodeChange} maxLength={5} pattern="[0-9]*"/>
                                </div>
                            </div>
                            <div className="form-group row"> 
                                <label className="col-sm-5 col-form-label">State <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <select id="states" className="form-control" required value={selectedValue} onChange={handleChange}>
                                        <option value="">Select State</option>
                                        <option value="Johor">Johor</option>
                                        <option value="Kedah">Kedah</option>
                                        <option value="Kelantan">Kelantan</option>
                                        <option value="Melaka">Melaka</option>
                                        <option value="Negeri Sembilan">Negeri Sembilan</option>
                                        <option value="Pahang">Pahang</option>
                                        <option value="Perak">Perak</option>
                                        <option value="Perlis">Perlis</option>
                                        <option value="Pulau Pinang">Pulau Pinang</option>
                                        <option value="Sabah">Sabah</option>
                                        <option value="Sarawak">Sarawak</option>
                                        <option value="Selangor">Selangor</option>
                                        <option value="Terengganu">Terengganu</option>
                                        <option value="Wilayah Persekutuan">Wilayah Persekutuan</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='text-center align-self-center'>
                                        <img src={"../images/tuneprotect.png"} alt="tune" className="img-fluid" width={320} />
                                        
                                    </div>
                                    <h6 className='text-center'>Total Yearly Premium</h6>
                                        <p className='text-center'>
                                            <span className='font-weight-bold h3 text-primary'>RM {parseFloat(props.addonsInfo.discountAmount).toFixed(2)}</span>
                                        </p>
                                        <hr></hr>
                                        <div className="row align-items-center">
                                            <label className="col-7">Basic Premium</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {parseFloat(props.addonsInfo.basic).toFixed(2)}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Add-Ons</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {parseFloat(props.addonsInfo.addons).toFixed(2)}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Service Tax (8%)</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {parseFloat(props.addonsInfo.tax).toFixed(2)}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Stamp Duty</label>
                                            <label className="col-5 text-right align-self-center">
                                                RM {parseFloat(props.addonsInfo.stamp).toFixed(2)}
                                            </label>
                                        </div>
                                        {props.addonsInfo.promo !== "" ? 
                                        <div className="row align-items-center">
                                            <label className="col-7 text-danger">Promo <br></br>({ props.addonsInfo.promo })</label>
                                            <label className="col-5 text-right align-self-center text-danger">
                                            - {`${props.addonsInfo.promoAmount}%`}
                                            </label>
                                        </div> 
                                        : 
                                        ""
                                        }

                                        <hr></hr>
                                        <div className="row align-items-center">
                                            <label className="col-7 font-weight-bold">Total Annual Payable</label>
                                            <label className="col-5 h5 text-right font-weight-bold text-primary align-self-center">
                                            RM {parseFloat(props.addonsInfo.discountAmount).toFixed(2)}
                                            </label>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group row mt-5 align-items-center">
                    <div className='col-6'>
                        <Button type="button" variant="info" className="mr-3" onClick={() => { props.setKey('question') }}>Back</Button>
                        </div>
                        <div className="col-6 text-right">
                            <Button type="submit">Continue</Button>
                            {/*
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                            */}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Summary(props) {
    let query = new URLSearchParams(useLocation().search);
    const [transactionData, setTransactionData] = useState([]);
    const [transactionNo] = useState(Math.floor(new Date().getTime() / 1000));
    const [isGetSummary, setIsGetSummary] = useState(false);
    const [onSave, setOnSave] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [periodFrom, setPeriodFrom] = useState(new Date());
    const [periodTo, setPeriodTo] = useState(addDays(addYears(new Date(), 1), -1));
    const currentDate = new Date(); 
    const targetDate = new Date('2024-03-01');
    const shouldShowAlert = currentDate < targetDate;

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.ownerInfo.length !== 0 && props.planInfo.length !== 0) {
            console.log("owner");
            console.log(props.ownerInfo);
            console.log("plan");
            console.log(props.planInfo);
            console.log("addons");
            console.log(props.addonsInfo);

            if (props.sumInfo.length !== 0) {
                const fetchData = async () => {
                  setLoading(true);
            
                  const loadingSwal = Swal.fire({
                    title: 'Please Wait...',
                    allowOutsideClick: false,
                    willOpen: () => {
                      Swal.showLoading();
                    },
                    showConfirmButton: false // Remove the "OK" button
                  });
            
                  const newData = {
                    product: props.ownerInfo.product,
                    quoteId: props.ownerInfo.quote,
                    plan: props.ownerInfo.plan,
                    amount: props.ownerInfo.amount,
                    postcode: props.ownerInfo.ownerPostcode,
                    state: props.ownerInfo.ownerstate,
                    address2: props.ownerInfo.ownerAddr2,
                    address1: props.ownerInfo.ownerAddr1,
                    idNo: props.ownerInfo.ownerIC,
                    nationality: props.ownerInfo.nationality,
                    phone: props.ownerInfo.ownerContactNo,
                    dob: props.ownerInfo.dob,
                    email: props.ownerInfo.ownerEmailAdd,
                    gender: props.ownerInfo.gender,
                    owner: props.ownerInfo.ownerName,
                    diabetic: props.ownerInfo.diabetic,
                    early: props.ownerInfo.early,
                    height: props.ownerInfo.height,
                    weight: props.ownerInfo.weight,
                    bmi: props.ownerInfo.bmi,
                    smoker: props.ownerInfo.smoker,
                    sumInsured: props.ownerInfo.sumInsured,
                    age: props.ownerInfo.age,
                    policyName: props.ownerInfo.policyName,
                    policyIC: props.ownerInfo.policyIC,
                    policyDOB: props.ownerInfo.policyDOB,
                    policyNationality: props.ownerInfo.policyNationality,
                    policyGender: props.ownerInfo.policyGender,
                    relationship: props.ownerInfo.relationship
                  };
            
                  try {
                    const response = await axios.post('/api/update', {
                      quote: newData
                    }, {
                      headers: {
                        "content-type": "application/json",
                      }
                    });
            
                    console.log(response);
                    setLoading(false);
                    Swal.close();
                  } catch (error) {
                    console.log(error);
                    // Handle errors accordingly
                    Swal.close();
                  }
                };
            
                fetchData();
            }

            setTransactionData({
                quoteId: props.ownerInfo.quote,
                name: props.ownerInfo.ownerName,
                idNo: props.ownerInfo.ownerIC,
                contactNo: props.ownerInfo.ownerContactNo,
                emailAdd: props.ownerInfo.ownerEmailAdd,
                gender: props.ownerInfo.gender,
                dob: props.ownerInfo.dob,
                insurer: "Tune Insurance Malaysia Berhad",
                product: props.ownerInfo.product,
                planName: props.ownerInfo.plan,
                premium: props.addonsInfo.basic,
                addons: props.addonsInfo.addons,
                serviceTax: props.addonsInfo.tax,
                stampDuty: props.addonsInfo.stamp,

                totalPay: props.addonsInfo.discountAmount,
                beforeDis: props.addonsInfo.amount,
                promo: props.addonsInfo.promo,
                periodFrom: Moment(periodFrom).format('YYYY-MM-DD'),
                periodTo: Moment(periodTo).format('YYYY-MM-DD'),
                TransactionNo: transactionNo,
                referral: props.referral,

                age: props.ownerInfo.age,
                policyName: props.ownerInfo.policyName,
                policyIC: props.ownerInfo.policyIC,
                policyDOB: props.ownerInfo.policyDOB,
                policyNationality: props.ownerInfo.policyNationality,
                policyGender: props.ownerInfo.policyGender,
                relationship: props.ownerInfo.relationship
            });
        } else if (query.get("paymentID") !== null) {
            axios.get('/api/order/' + query.get("paymentID"))
                .then(res => {
                    var trans = res.data[0]['trans'];
                    console.log(trans);
                    setTransactionData({
                        name: trans.name,
                        idNo: trans.idNo,
                        contactNo: trans.contactNo,
                        emailAdd: trans.emailAdd,
                        gender: trans.gender,
                        dob: Moment(trans.dob).format('YYYY-MM-DD'),
                        nominee: trans.nominee,
                        nomineeId: trans.nomineeId,
                        nomineeRelationship: trans.nomineeRelationship,
                        promo: trans.promo,
                        car: trans.car,
                        insurer: trans.insurer,
                        planName: trans.planName,
                        benefit: trans.benefit,
                        premium: trans.premium,
                        serviceTax: trans.serviceTax,
                        stampDuty: trans.stampDuty,
                        totalPay: trans.totalPay,
                        periodFrom: Moment(trans.periodFrom).format('YYYY-MM-DD'),
                        periodTo: Moment(trans.periodTo).format('YYYY-MM-DD'),
                        TransactionNo: transactionNo,
                        payment_status: trans.payment_status,
                        txn_message: trans.txn_message
                    });
                    setIsGetSummary(true);
                })
        }
    }, [props.ownerInfo, props.planInfo]);

    useEffect(() => {
        if (onSave === true && transactionData.length !== 0) {
            // axios({
            //     method: 'POST',
            //     url: '/api/inserttransaction',
            //     headers: {
            //         "content-type": "application/json",
            //     },
            //     data: {
            //         trans: transactionData
            //     }
            // })
            //     .then(function (response) {
            //         console.log(response);
            //         document.getElementById('details-form').submit();
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     })
            const fetchData = async () => {
                setLoading(true);
          
                const loadingSwal = Swal.fire({
                  title: 'Please Wait...',
                  allowOutsideClick: false,
                  willOpen: () => {
                    Swal.showLoading();
                  },
                  showConfirmButton: false // Remove the "OK" button
                });
          
                try {
                  const response = await axios.post('/api/initial', {
                    quote: transactionData
                  }, {
                    headers: {
                      "content-type": "application/json",
                    }
                  });
          
                  console.log(response);
                  document.getElementById('details-form').submit();
                  setLoading(false);
                  Swal.close();
                } catch (error) {
                  console.log(error);
                  // Handle errors accordingly
                  Swal.close();
                }
              };
          
              fetchData();
        }
    }, [onSave]);

    let merchantAcc = process.env.MIX_PAYMENT_GATEWAY_PASSWORD;
    let serviceID = process.env.MIX_PAYMENT_GATEWAY_SERVICE_ID;
    let merchantReturnURL = process.env.MIX_APP_URL + "/api/store";
    //let merchantReturnURL = "http://127.0.0.1:8000/api/store";
    let currencyCode = "MYR";
    let ip = process.env.MIX_APP_URL;
    let timeout = "600";
    let HashValue = SHA256(merchantAcc + serviceID + transactionNo + merchantReturnURL + Number(transactionData.totalPay).toFixed(2) + currencyCode + ip + timeout);

    function PaymentSuccess() {
        return (<div className="alert alert-success" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentFail() {
        return (<div className="alert alert-danger" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentPending() {
        return (<div className="alert alert-warning" role="alert">
            Your Payment is still Pending.
        </div>);
    }

    function Message() {
        if (transactionData.payment_status == 'Pending') {
            return <PaymentPending />;
        } else if (transactionData.payment_status == 'Success') {
            return <PaymentSuccess />;
        } else if (transactionData.payment_status == 'Fail')
            return <PaymentFail />
        else return <></>
    }

    return (
        <div>
            {transactionData.length !== 0 ?
                <Form action={process.env.MIX_PAYMENT_GATEWAY_URL} method="POST" id="details-form">
                    <input type="hidden" name="TransactionType" value="SALE" />
                    <input type="hidden" name="PymtMethod" value="ANY" />
                    {/* <input type="hidden" name="PymtMethod" value="CC" /> */}
                    <input type="hidden" name="ServiceID" value={serviceID} />
                    <input type="hidden" name="PaymentID" value={transactionNo} />
                    <input type="hidden" name="OrderNumber" value={transactionNo} />
                    <input type="hidden" name="PaymentDesc" value="Payment for Critical Illness" />
                    <input type="hidden" name="MerchantReturnURL" value={merchantReturnURL} />
                    <input type="hidden" name="Amount" value={Number(transactionData.totalPay).toFixed(2)} />
                    <input type="hidden" name="CurrencyCode" value={currencyCode} />
                    <input type="hidden" name="CustName" value={transactionData.name} />
                    <input type="hidden" name="CustPhone" value={transactionData.contactNo} />
                    <input type="hidden" name="CustEmail" value={transactionData.emailAdd} />
                    <input type="hidden" name="CustIP" value={ip} />
                    <input type="hidden" name="PageTimeout" value={timeout} />
                    <input type="hidden" name="LanguageCode" value="en" />
                    <input type="hidden" name="HashValue" value={HashValue} />
                    <div className="px-3 row">
                        <div className="col-12">
                            <div className="my-2">
                                {isGetSummary ? <Message /> : null}
                            </div>
                            <Card className="my-2">
                                <Card.Header className="text-primary font-weight-bold">Summary of Policy</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">

                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Insurer</label>
                                                <label className="col-6 col-form-label text-right">{transactionData.insurer}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Product</label>
                                                <label className="col-6 col-form-label text-right">Critical Safe+</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Plan Name</label>
                                                <label className="col-6 col-form-label text-right">{transactionData.planName === "TPMPR2CI" ? "Top 2 CI" : "Top 5 CI"}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Coverage Starts</label>
                                                <label className="col-6 col-form-label text-right">{Moment(transactionData.periodFrom).format('Do MMM YYYY')}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Coverage Ends</label>
                                                <label className="col-6 col-form-label text-right">{Moment(transactionData.periodTo).format('Do MMM YYYY')}</label>
                                            </div>
                                        </div>
                                        <div id="payment" className="col-md-6">

                                            <div className="form-group row mb-0">
                                                <label className="col-12 col-form-label font-weight-bold pb-0">Summary of Plan</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Basic Premium</label>
                                                <label className="col-6 col-form-label text-right">RM {parseFloat(transactionData.premium).toFixed(2)}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Add-ons</label>
                                                <label className="col-6 col-form-label text-right">RM {parseFloat(transactionData.addons).toFixed(2)}</label>
                                            </div>
                                                <div className="form-group row">
                                                <label className="col-6 col-form-label">Service Tax 8%</label>
                                                <label className="col-6 col-form-label text-right">RM {transactionData.serviceTax}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Stamp Duty</label>
                                                <label className="col-6 col-form-label text-right">RM {transactionData.stampDuty}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                                <Card.Footer>
                                    <div className="row font-weight-bold">
                                        <label className="col-6 col-form-label">Total Amount Payable</label>
                                        <label className="col-6 col-form-label text-right">RM {transactionData.totalPay.toFixed(2)}</label>
                                        <label className='col-12 text-muted' style={{ 'font-size': '11px'}}>15% of commission amounting to RM {(parseFloat(transactionData.premium) * 0.15 ).toFixed(2)} is payable to intermediary</label>
                                    </div>
                                </Card.Footer>
                            </Card>
                            <Card>
                                <Card.Header className="text-primary font-weight-bold">Insured Details</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Full Name</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.name}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">NRIC / Passport No.</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.idNo}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Gender</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.gender}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Date Of Birth</label>
                                                <label className="col-6 col-form-label text-right text-primary">{Moment(transactionData.dob).format('Do MMM YYYY')}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Contact Number</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.contactNo}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-5 col-form-label">Email</label>
                                                <label className="col-7 col-form-label text-right text-primary">{transactionData.emailAdd}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
{transactionData.age < 18 ? 
                                <Card>
                                <Card.Header className="text-primary font-weight-bold">Policyholder Details</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Full Name</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.policyName}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">NRIC / Passport No.</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.policyIC}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Gender</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.policyGender}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Date Of Birth</label>
                                                <label className="col-6 col-form-label text-right text-primary">{Moment(transactionData.policyDOB).format('Do MMM YYYY')}</label>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-6 col-form-label">Relationship</label>
                                                <label className="col-6 col-form-label text-right text-primary">{transactionData.relationship}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            : 
                            ""
                            }
                            <div className="form-group row mt-5 align-items-center">
                                <div className='col-lg-12'>
                                    {shouldShowAlert && (
                                        <div className="alert alert-danger" role="alert">
                                            Disclaimer: As announced by the government in the Budget 2024, <b>effective from 1st March 2024</b>, the adjustment of service tax from <b>6% to 8%</b> is applicable to all insurance services. Please be informed that any modifications or augmentation in service tax attributable to this revision is the responsibility of the insurance policy holder. The additional payable service tax is also applicable to any policy that is procured before 1st March 2024 but with a period of insurance spanning across 1st March 2024. Therefore, Howden Insurance Brokers Sdn Bhd reserves the right to collect any additional service tax on behalf of the Royal Malaysian Customs Department.
                                        </div>
                                    )}
                                </div>
                                <div className='col-6'>
                                <Button type="button" variant="info" className="mr-3" onClick={() => { props.setKey('owner') }}>Back</Button>
                                </div>
                                <div className="col-6 text-right">
                                <Button type="button" variant="success" className="mb-3 mt-3"  onClick={() => setModalShow(true)}>Pay Now</Button>
                                </div>
                            </div>


                            <PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} name={transactionData.name} age={transactionData.age} policy={transactionData.policyName} setOnSave={setOnSave} />
                        </div>
                    </div>
                </Form>
                :
                <div className="text-center">
                    <br />
                    <img src="../images/loading.gif" />
                    <br />
                    Please wait
                    <br />
                </div>
            }
        </div >
    );

}

function PromptConfirmation(props) {
    const [agreed, setAgreed] = useState(null);

    const useAnalyticsEventTracker = (category = "Instapol - GA4 category") => {
        const eventTracker = (action = "test action", label = "test label") => {
            ReactGA.event({ category, action, label });
        }
        return eventTracker;
    }
    const gaEventTracker = useAnalyticsEventTracker('Payment');

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 text-justify">
                        <div className="col-12">I, <span className="text-primary">{props.age < 18 ? props.policy : props.name}</span>, confirmed that:</div>
                        <p className="mt-3">
                            - I understand that it is my duty to take reasonable care not to make a misrepresentation in answering the questions and hereby declare that I have fully and accurately answered the questions in this Application..
                        </p>
                        <p className="mt-3">
                            - I have read, understood and accepted the <a href="storage/pdf/pds.pdf" target="_blank" className="text-decoration-none">Product Disclosure Sheet</a>, <a href="storage/pdf/pw.pdf" target="_blank" className="text-decoration-none">Policy Wording</a> and
                            <a href="https://www.howdengroup.com/my-en/privacy-and-data-protection" className="text-blue text-decoration-none" target="_blank"> Privacy Policy</a> for this product.
                        </p>
                        <div className="row text-center mt-4">
                            <div className="col-12">
                                <input type="radio" value="true" name="disclosure" onChange={() => setAgreed(true)} /> Agree
                                <input className="ml-4" type="radio" value="false" name="disclosure" onChange={() => setAgreed(false)} /> Disagree
                            </div>
                            {(agreed === false) ?
                                <div className="col-12 text-danger">You have to agree to our terms in order to complete the transaction.</div>
                                : ''
                            }
                        </div>
                        <div className="col-12 mt-4">
                            <strong>
                                Please make sure you review the order and personal details before payment page. Once you click 'Pay Now' you cannot
                                change these details.
                            </strong>
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className="row text-right">
                    <div className="col-5">
                        <Button type="button" variant="secondary" onClick={props.onHide}>Cancel</Button>
                    </div>
                    <div className="col-7">
                        <Button type="button" variant="success" form="details-form" disabled={isNull(agreed) || agreed === false ? 'disabled' : ''} onClick={(e) => { props.setOnSave(true); gaEventTracker('email'); }}>Pay Now</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
